import cx from 'classnames';
import React, { useEffect, useState } from 'react';

import styles from './plan.module.css';
import { BasicInfoSection } from 'app/shared/info-section/basic';
import { DetailItem } from 'app/shared/info-section/item';
import { useSubscriptionService } from 'hooks/sales/subscription';
import ConfirmationDialog from 'app/shared/dialogs/confirmation';
import { toast } from 'react-toastify';
import { toReadableNumber } from 'app/shared/utils/number';
import { NoSubscription } from 'app/member/modules/checkout/nosub';
import { useTenant } from 'contexts/tenant';

export const PlanDetails = () => {
  const { is_agency_managed } = useTenant();
  const [show_cancel_subscription, setCancelSubscription] = useState(false);
  const [subscription, setSubscription] = useState(null);

  const { cancelSubscription, fetchSubscription } = useSubscriptionService();

  useEffect(() => {
    fetchSubscription({ query_string: `status=active` }).then(
      ({ subscriptions: [subscription], error }) => {
        if (error) return toast.error(error);
        setSubscription(subscription);
      }
    );
  }, []);

  const handleCancelSubscription = async (permitted) => {
    if (permitted) {
      await cancelSubscription(subscription.id);
      setSubscription(null);
    }
    setCancelSubscription(false);
  };

  return subscription ? (
    <>
      <BasicInfoSection title="Plan Details">
        <>
          <DetailItem title="CURRENT PLAN">
            {subscription?.title} ({subscription?.renewal_period}ly)
          </DetailItem>
          {!is_agency_managed && (
            <DetailItem title="COST">
              {`${subscription?.price.currency.code} ${toReadableNumber(
                subscription?.price.amount
              )}`}
            </DetailItem>
          )}
          <DetailItem title="DUE DATE">
            {new Date(subscription?.expires_at).toDateString()}
          </DetailItem>
          <DetailItem title="Email Usage">
            {toReadableNumber(subscription?.resources.usage)}/
            {toReadableNumber(subscription?.resources.limit)} emails
          </DetailItem>
          {!subscription?.is_canceled && (
            <a onClick={() => setCancelSubscription(true)} className={cx(styles.linkBtn)}>
              Cancel Subscription
            </a>
          )}
        </>
      </BasicInfoSection>
      <ConfirmationDialog
        type="error"
        title="Cancel Subscription"
        message={<p>You are about to cancel your subscription. This action cannot be undone.</p>}
        callback={handleCancelSubscription}
        is_open={show_cancel_subscription}
      />
    </>
  ) : (
    <BasicInfoSection>
      <NoSubscription />
    </BasicInfoSection>
  );
};
